export default __webpack_public_path__ + "static/media/manual06.b5b29dcb.png";